import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as moment from "moment";
import { DownloadShipDetails } from "../Actions/ClientDashboardAPI";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { withTranslation } from "react-i18next";
class NotesManagementCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            first: 0,
            rows: 10,
            first2: 0,
            rows2: 10,
        };
    }



    renderedit(props) {
        return (
            <Popover id="history-tooltip" {...props}>
                <Popover.Content>
                    <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
                </Popover.Content>
            </Popover>
        );
    }

    renderdelete(props) {
        return (
          <Popover id="history-tooltip" {...props}>
            <Popover.Content>
              <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
            </Popover.Content>
          </Popover>
        );
      }


    render() {
        const { arraylist, pageSize, totalRecords, t } = this.props;
        console.log("array", arraylist);
        return (
            <div className="pb-3">
                {this.renderCardData()}
                {arraylist && arraylist.length !== 0 ? (
                    <Paginator
                        first={this.state.first}
                        rows={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={(e) => this.onPaginatorChange(e)}
                    ></Paginator>
                ) : (
                    <div
                        className="card"
                        style={{ overflow: "hidden", position: "relative" }}
                    >
                        <div class="container">
                            <h6 className="resource-list-title no-item-card">
                                !--{t("CommonText.NoItem")}--!
                            </h6>
                        </div>
                    </div>
                )}
            </div>
        );
    }
    onPaginatorChange(event) {
        this.setState({
            first: event.first,
        });
        const { setUpdatedState } = this.props;
        setUpdatedState(event.page + 1);
    }
    renderCardData = () => {
        const { showSidePane, arraylist, EditNotes, DeleteNotes, t } = this.props;
        return arraylist && arraylist.length
            ? arraylist.map((item, index) => {
                console.log("item", item.shipName);
                return (
                    <div
                        className="card mb-2"
                        style={{ overflow: "hidden", position: "relative" }}
                    >
                        <div className="p-2">
                            <div className="resource-list-auth-date">
                                <div className="row px-4">
                                    <div
                                        className={
                                            // item.isDeleted
                                            "col-sm-10 col-md-11 col-10 m-auto"
                                        }
                                    >
                                        <div className="row">
                                            <div
                                                className={
                                                    showSidePane ? "col-sm-6" : "col-sm-4"
                                                }
                                            >
                                                <span>
                                                    <strong className={item.isDeleted ? "strick" : ""}>
                                                        {t("DashboardShipReports.Title")} :{" "}
                                                    </strong>
                                                    <span
                                                        className={
                                                            item.isDeleted
                                                                ? "italicFont strick"
                                                                : "italicFont "
                                                        }
                                                    >
                                                        {item.title}{" "}
                                                    </span>
                                                </span>
                                            </div>
                                            <div
                                                className={
                                                    showSidePane ? "col-sm-6" : "col-sm-4"
                                                }
                                            >
                                                <span>
                                                    <strong className={item.isDeleted ? "strick" : ""}>
                                                        {t("DashboardShipReports.Date")} :{" "}
                                                    </strong>
                                                    <span
                                                        className={
                                                            item.isDeleted
                                                                ? "italicFont strick"
                                                                : "italicFont "
                                                        }
                                                    >
                                                        {item.date
                                                            ? moment(item.date).format(
                                                                "DD MMM YYYY"
                                                            )
                                                            : ""}
                                                    </span>
                                                </span>
                                            </div>
                                            <div
                                                className={
                                                    showSidePane ? "col-sm-6" : "col-sm-4"
                                                }
                                            >
                                                <span>
                                                    <strong className={item.isDeleted ? "strick" : ""}>
                                                        {t("DashboardShipReports.Remarks")} :{" "}
                                                    </strong>
                                                    <span
                                                        className={
                                                            item.isDeleted
                                                                ? "italicFont strick"
                                                                : "italicFont "
                                                        }
                                                    >
                                                        {item.remarks}{" "}
                                                    </span>
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                    {!item.isDeleted ? (
                                        <div className="col-sm-2 col-md-1 col-2 m-auto text-right">
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={this.renderedit()}
                                            >
                                                <i
                                                    className="fa fa-edit fa-lg click m-1"
                                                    onClick={() => EditNotes(item)}
                                                    aria-hidden="true"
                                                    style={{
                                                        color: " #1a3464",
                                                        fontSize: "1.8rem",
                                                        marginLeft: "-15px",
                                                    }}
                                                ></i>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={this.renderdelete()}
                                            >
                                            <i
                                                className="fa fa-trash click m-1"
                                                aria-hidden="true"
                                                style={{ color: " #1a3464", fontSize: "1.8rem" }}
                                                onClick={() => DeleteNotes(item)}
                                            ></i>
                                            </OverlayTrigger>
                                        </div>
                                    )
                                        : (
                                            <div className="col-sm-2 col-md-1 col-2 m-auto text-right">
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })
            : null;
    };
}

function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default withTranslation()(withRouter(
    connect(mapStateToProps, mapDispatchToProps)(NotesManagementCard))
);
